<div class="site-header p-2 pr-0 bg-gray-900 z-11 relative flex align-items-center h-3rem" aria-label="site-header">
  <a pRipple class="cursor-pointer block xl:hidden text-white mr-2" pStyleClass=".app-sidebar-wrapper"
    enterFromClass="hidden" enterActiveClass="fadeinleft" leaveToClass="hidden" leaveActiveClass="fadeoutleft"
    [hideOnOutsideClick]="true" hideOnEscape="true" aria-label="toggle-sidebar-button">
    <i class="fa fa-bars text-3xl opacity-80"></i>
  </a>
  <div class="flex align-items-center justify-content-end md:justify-content-between w-full">

    <client-omnisearch class="md:w-full" (prospectEvent)="createProspectEvent($event)" (clientProfileEvent)="goToClientProfileDetails($event)" aria-label="client-search" />


    <!-- Create -->
    <div class="relative mr-2 md:ml-2">
      <div class="white-space-nowrap" [ngClass]="{'opacity-40 pointer-events-none':isTenantInActive}" pStyleClass="@next" enterFromClass="hidden"
        enterActiveClass="fadein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true" aria-label="create-menu">
        <div class="hidden md:inline-block">
          <p-button styleClass="text-sm line-height-1 h-2rem py-0" [label]="'common.PLACEHOLDER.CREATE' | translate" icon="fa fa-plus" aria-label="create-button" />
        </div>
        <div class="md:hidden">
          <p-button styleClass="text-sm bg-gray-800 border-700 text-100 w-2rem h-2rem" icon="fa fa-plus" aria-label="create-button-mobile" />
        </div>
      </div>
      <ul class="list-none p-0 w-10rem absolute left-0 top-0 mt-5 shadow-2 w-100 surface-0 border-round hidden py-2" aria-label="create-options">
        <li class="cursor-pointer hover:surface-50 py-2 px-4" (click)="OpenPopup('prospect')" aria-label="create-prospect-option">{{'common.BUTTONS.BTN_CREATE_PROSPECT' | translate}}</li>
        <li class="cursor-pointer hover:surface-50 py-2 px-4" (click)="OpenPopup('walk-in-tour')" aria-label="create-tour-option">{{'common.BUTTONS.BTN_CREATE_TOUR' | translate}}</li>
        <li class="cursor-pointer hover:surface-50 py-2 px-4" (click)="OpenPopup('walk-in-trial')" aria-label="create-trial-option">{{'common.BUTTONS.BTN_CREATE_TRIAL' | translate}}</li>
        <li class="cursor-pointer hover:surface-50 py-2 px-4" (click)="OpenPopup('walk-in-member')" aria-label="create-member-option">{{'common.BUTTONS.BTN_CREATE_MEMBER' | translate}}</li>
      </ul>
    </div>
    <!-- Create -->
    <!-- Create Prospect -->


    <div class="md:w-24rem text-white md:border-left-1 border-gray-600 md:pl-2 flex align-items-center">
      <!-- Tenant Dropdown -->
      <div class="relative lg:z-2 w-3rem lg:w-17rem" aria-label="tenant-selector">
        <multi-tenant-list [selectedTenantId]="selectedTenant && selectedTenant!.id"
          (emittedTenant)="selectTenant($event)" />
      </div>
      <!-- Tenant Dropdown -->


      <!-- Notification -->
      <div class="px-3 py-2 h-3rem ml-2 bg-gray-800 flex align-items-center justify-content-end" aria-label="notification-section">
        @if (showStaffNotificationIcon.getValue()) {
          <div class="relative cursor-pointer" aria-label="staff-notification">
            <p-button (onClick)="onStaffNotificationIconClick()" icon="fa fa-comments"
            styleClass="border-gray-700 bg-900 border-circle" aria-label="staff-notification-button" />
            <strong
            class="h-1rem w-1rem text-white bg-red border-circle flex align-items-center justify-content-center absolute right-0 top-0 text-xs" aria-label="staff-notification-count">{{ staffNotificationCount }}</strong>
          </div>
        }
        <div class="relative ml-2" aria-label="changelog-notification">
          <p-button icon="fa fa-bullhorn" styleClass="border-gray-700 bg-900 border-circle" data-featurebase-changelog (onClick)="openChangeLog()" aria-label="changelog-button" />
          <strong id="fb-update-badge"
          class="h-1rem w-1rem text-white bg-red border-circle flex align-items-center justify-content-center absolute right-0 top-0 text-xs" aria-label="changelog-update-count"></strong>
        </div>
      </div>
      <!-- Notification -->

      <!-- Theme Switcher -->
      <!-- <div class="theme-switcher mr-2">
      <p-selectButton [options]="themes" [(ngModel)]="selectedTheme"
        (onOptionClick)="changeTheme($event.option.value)" styleClass="theme-buttons">
        <ng-template let-item>
          <i [class]="item.value.includes('dark') ? 'pi pi-moon' : 'pi pi-sun'"></i>
        </ng-template>
      </p-selectButton>
    </div> -->
  </div>

</div>
</div>

@if (createProspect | async; as showPopup) {
  <create-client-profile-sidebar [formType]="formType" [searchData]="searchData" [showProspect]="showPopup" [clientId]="clientId"
    (hideProspect)="hidePopup($event)" (proceedToSignup)="proceedToSignup($event)" (GoToClientDetails)="goToclientProfile($event)" aria-label="create-client-profile-sidebar" />
}

@if (showClientSidebar) {
  <fitness-force-client-info-sidebar [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId" [activeTab]="activeTab"
    (closeSidebar)="CloseSidebar($event)" aria-label="client-info-sidebar" />
}

@if (showNotificationSidebar) {
  <staff-notification-sidebar [showSidebar]="showNotificationSidebar" [notificationData]="staffNotifications"
    (closeSidebar)="closeNotificationSidebar($event)" aria-label="staff-notification-sidebar" />
}

@if (showPaidFullSidebar) {
  <billing [visible]="showPaidFullSidebar" (onHide)="closeDialog()"  (onHide)="closeDialog()"  [billedAtTenantId]="selectedTenant && selectedTenant!.id" [planSummarydata]="planSummarydataObject$" [showbilling]="showPaidFullSidebar" closeOnEscape="false" (closeSidePopupMember)="hideBillingSummary($event)" aria-label="billing-sidebar" />
}
<!--
<p-button (click)="OpenPopup('prospect')" styleClass="md:hidden fixed right-0 bottom-0 z-5 mr-4 mb-4 h-3rem w-3rem p-button-rounded p-button-raised" icon="fa fa-user-plus" [disabled]="isTenantInActive"></p-button> -->